<template>
  <div class="interview-content" :id="scrollContainerId">
    <div class="interview-content__inner">
      <h1 class="interview-content__title">{{ title }}</h1>

      <section
        v-for="question of content"
        :key="question.title"
        class="interview-content__section"
      >
        <TextBlock
          class="interview-content__section__question"
          :title="question.title"
          :paragraphs="question.paragraphs"
        />
      </section>
    </div>

    <TvaScrollBar
      v-if="withScrollbar && !smallscreen"
      :scrollContainerId="scrollContainerId"
    />
  </div>
</template>

<script setup>
import TextBlock from "./TextBlock.vue";
import TvaScrollBar from "./TvaScrollBar.vue";

defineProps({
  title: String,
  content: {
    type: Array,
    default: () => [],
  },
  withScrollbar: {
    type: Boolean,
    default: true,
  },
  smallscreen: Boolean,
});

const scrollContainerId = "interview-container";
</script>

<style lang="scss" scoped>
.interview-content {
  --offset-top: 0;

  padding: calc(var(--modal-padding) * 2);
  height: calc(var(--vh) * 100 - var(--offset-top));
  overflow: auto;

  .mobile &,
  .tablet & {
    // This is about the size of the interviewee info box in mobile
    --offset-top: #{toRem(175)};

    padding: calc(var(--modal-padding) * 2) var(--modal-padding);
  }

  &__title {
    .desktop &,
    .large & {
      @include title-l;

      margin-bottom: 3.5vh;
    }

    .mobile &,
    .tablet & {
      @include title-s;

      margin-bottom: 1rem;
    }
  }

  &__section {
    &:not(:last-child) {
      border-bottom: 1px solid var(--scala-grigi-gray-3);
    }

    &__question {
      padding: 2rem 0 !important;

      .mobile &,
      .tablet & {
        ::v-deep(.text-title) {
          @include title-xs;
        }
      }
    }
  }
}
</style>
